import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_NEW_SITE,
  UPDATE_NEW_SITE,
  SITE_DATA,
  DRAWING_DATA,
  DELETE_SITE_BYID,
  ADD_CHANGEREQUEST,
  ALL_SITE_DATA_SUCCESS, CHANGEREQUEST_BY_SITEID,SITE_DATA_DROPDOWN
} from "./actiontype";
import {
  onAddnewSiteError,
  onAddnewSiteSuccess,
  onupdateSiteSuccess,
  onupdateSiteError,
  onDeletesiteSuccess,
  onDeletesiteError,
  togglePageLoader,
  siteListError,
  siteListByClientSuccess,
  drawinglistbysiteSucess,
  drawinglistbysiteError,
  siteListSuccess,
  ChangeRequestListSuccess, ChangeRequestError,
  onAddnewChangeRequestSuccess, onAddnewChangeRequestError,sitedropDownListSuccess
} from "../actions";

import { getSitebyCliendId, getDrawingbySiteId, getAllSites, postAddSite, patchUpdateSite, deleteSiteById, getChangeRequestbySiteId, postAddChangeRequest } from "../../helpers/api";

import toast from "toastr";
import { notifications } from "@mantine/notifications";

function* getSitesList({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getSitebyCliendId, params, exportname);
    if (response?.clientSiteRequests && response?.clientSiteRequests?.length > 0) {
       localStorage.setItem("SitebyClientId", response.clientSiteRequests[0].clientId);
     }
    if (exports !== "export") {
      if (response) {
        yield put(siteListByClientSuccess(response));
        yield put(togglePageLoader(false));
      } else {
        yield put(siteListError(response));
        toast.error(response.message);
        yield put(togglePageLoader(false));
      }
     } 
     else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}
function* createnewsite({ payload: params, callback }) {

  try {
    yield put(togglePageLoader(true));
    const response = yield call(postAddSite, params);
    if (response && response.message!=="Site name already exists.") {
    yield put(onAddnewSiteSuccess(response));
    yield put(togglePageLoader(false));
    toast.success(response.message);
    callback("ADD SUCCESS");
    } else {
    //notificationColor = "red";
    yield put(onAddnewSiteError(response));
    toast.error(response.message);
    yield put(togglePageLoader(false));
    callback("ADD FAILURE");
    }
  } catch (error) {
    yield put(onAddnewSiteError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* updatenewSite({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(patchUpdateSite, data);

    if (response && response.message!=="Site name already exists.") {
      yield put(onupdateSiteSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      callback("SUCCESS");
    } else {
      yield put(onupdateSiteError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onupdateSiteError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* deleteSite({ payload: userId, callback }) {

  try {
    yield put(togglePageLoader(true));
    const response = yield call(deleteSiteById, userId);

    if (response) {
      yield put(onDeletesiteSuccess(userId));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      callback("SUCCESS");
    } else {
    
      yield put(onDeletesiteError(response));
      toast.error(response.message);
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onDeletesiteError(error));
    toast.error(error?.response ? error.response.data.message : error.message);
  } finally {
    yield put(togglePageLoader(false));
  }
}
function* fetchDrawingBySiteId({ payload: params, exports, exportname }) {

  try {
    yield put(togglePageLoader(true));
    const response = yield call(getDrawingbySiteId, params, exportname);

    if (exports !== "export") {
      if (response.statusCode === 200) {
      yield put(drawinglistbysiteSucess(response));
      yield put(togglePageLoader(false));
       } else {
      yield put(drawinglistbysiteError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
    }
    } 
    else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}
function* fetchChangeRequestBySiteId({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getChangeRequestbySiteId, params, exportname);
    if (exports !== "export") {
      if (response.statusCode === 200) {
        yield put(ChangeRequestListSuccess(response));
        yield put(togglePageLoader(false));
      } else {
        yield put(ChangeRequestError(response.message));
        toast.error(response.message);
        yield put(togglePageLoader(false));
      }
    }
    else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "An error occurred");
    yield put(togglePageLoader(false));
  }
}
function* getAllSitesList({ payload: params }) {
  try{
    const response = yield call(getAllSites, params);
    if(response.message !== "No sites found."){
      yield put(siteListSuccess(response));
    }
  }
  catch(error){
    yield put(siteListSuccess([]));
  }
}

function* createnewChangeRequest({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true));
    const reqFormData = new FormData();
    reqFormData.append("siteId", parseInt(params.siteId, 10));
    reqFormData.append("clientId", params.clientId ? parseInt(params.clientId, 10) : 0);
    if (params.requestDate) {
      reqFormData.append("requestDate", params.requestDate ? new Date(params.requestDate).toISOString() : '');
    }
    reqFormData.append("applicantName", params.applicantName);
    reqFormData.append("applicantEmail", params.applicantEmail);
    reqFormData.append("changeTypeId", parseInt(params.changeTypeId, 10));
    reqFormData.append("changeRequestComment", params.changeRequestComment);
    reqFormData.append("uploadDrawings", params.uploadDrawings);
    reqFormData.append("commissionCertificate", params.commissionCertificate);
    reqFormData.append("manufacturersLiterature", params.manufacturersLiterature);
    reqFormData.append("approveDeclaration", params.approveDeclaration);
    reqFormData.append("fileUpload", params.fileUpload);

    const response = yield call(postAddChangeRequest, reqFormData);
    if (response.statusCode === 200) {
      yield put(onAddnewChangeRequestSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.message);
      callback("ADD SUCCESS");
    } else {
      yield put(onAddnewChangeRequestError(response));
      toast.error(response.message);
      yield put(togglePageLoader(false));
      callback("ADD FAILURE");
    }
  } catch (error) {
    yield put(onAddnewChangeRequestError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}
function* getSitesdropdownList({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getSitebyCliendId, params, exportname);
    if (response.clientSiteRequests && response.clientSiteRequests.length > 0) {
      localStorage.setItem("SitebyClientId", response.clientSiteRequests[0].clientId);
    } else {
      toast.error(response.message);
    }

    if (exports !== "export") {
      if (response.statusCode === 200) {
        yield put(sitedropDownListSuccess(response));
        yield put(togglePageLoader(false));
      } else {
        yield put(siteListError(response));
        toast.error(response.message);
        yield put(togglePageLoader(false));
      }
    }
    else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* sitelist() {
  yield takeEvery(SITE_DATA, getSitesList);
  yield takeEvery(DRAWING_DATA, fetchDrawingBySiteId);
  yield takeEvery(ALL_SITE_DATA_SUCCESS, getAllSitesList);
  yield takeEvery(ADD_NEW_SITE, createnewsite);
  yield takeEvery(CHANGEREQUEST_BY_SITEID, fetchChangeRequestBySiteId);
  yield takeEvery(ADD_CHANGEREQUEST, createnewChangeRequest);
  yield takeEvery(UPDATE_NEW_SITE, updatenewSite);
  yield takeEvery(DELETE_SITE_BYID, deleteSite);
  yield takeEvery(SITE_DATA_DROPDOWN, getSitesdropdownList);
  
}

export default sitelist;
